// extracted by mini-css-extract-plugin
module.exports = {"buttons-wrapper":"BicycleAdd_buttons-wrapper__1-Xq6"};